import { LayerSpecification } from 'maplibre-gl';
import { MapSourceId } from '@daisi/models/map';

export const BRIDGES_SOURCE_ID: MapSourceId = 'realtime-bridges';

// Approximations of the design system's positive, warning and critical colours. No history means
// no severity, and then no halo.
const SEVERITY_COLORS = [
  'match',
  ['get', 'severity'],
  'normal',
  '#2f7a2d',
  'above-average',
  '#e0a100',
  'long',
  '#d4351c',
  'rgba(0, 0, 0, 0)',
];

// Higher is drawn on top, so red bridges cover green ones where they overlap.
const SEVERITY_SORT_KEY = [
  'match',
  ['get', 'severity'],
  'long',
  3,
  'above-average',
  2,
  'normal',
  1,
  0,
];

export const BRIDGES_LAYERS: LayerSpecification[] = [
  {
    id: BRIDGES_SOURCE_ID + '_bridgeClosed',
    type: 'symbol',
    minzoom: 12,
    layout: {
      'icon-image': 'ndw-bridgeClosed-25',
      'icon-allow-overlap': true,
    },
    filter: ['==', 'open', false],
    source: BRIDGES_SOURCE_ID,
  },
  // A halo behind the open-bridge icon, coloured by how long it has been open.
  {
    id: BRIDGES_SOURCE_ID + '_bridgeOpenSeverity',
    type: 'circle',
    layout: {
      'circle-sort-key': SEVERITY_SORT_KEY as any,
    },
    paint: {
      'circle-radius': 16,
      'circle-color': SEVERITY_COLORS as any,
      'circle-opacity': 0.5,
      'circle-stroke-width': 2,
      'circle-stroke-color': SEVERITY_COLORS as any,
    },
    filter: ['==', 'open', true],
    source: BRIDGES_SOURCE_ID,
  },
  {
    id: BRIDGES_SOURCE_ID + '_bridgeOpenSymbol',
    type: 'symbol',
    layout: {
      'icon-image': 'ndw-bridgeswing-25',
      'icon-allow-overlap': true,
      'symbol-sort-key': SEVERITY_SORT_KEY as any,
    },
    filter: ['==', 'open', true],
    source: BRIDGES_SOURCE_ID,
  },
  {
    id: BRIDGES_SOURCE_ID + '_bridgeOpenLine',
    type: 'line',
    layout: {
      'line-join': 'round',
      'line-cap': 'round',
    },
    paint: {
      'line-width': 2,
      'line-color': '#FF0000',
    },
    filter: ['==', 'open', true],
    source: BRIDGES_SOURCE_ID,
  },
];
